module.exports = __webpack_public_path__ + "static/img/121_TO8_1661_og.a9c80f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/121_TO8_1661_og.jpg
// module id = WM8t
// module chunks = 0